import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminEditStandardFeePage = React.lazy(() => import(/* webpackChunkName: "AdminEditStandardFee" */ './Page'));
export const AdminEditStandardFee = () => (React.createElement(Page, { title: "Administrator Edit Standard Fee" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminEditStandardFeePage, null)))));
